import React from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Signup() {
  const { brand } = useOutletContext();
  const { brand: key } = useParams();
  const dark = brand.key === "blackpekoe";
  const fg = dark ? "#F5F2EB" : "#2D2622";
  const muted = dark ? "rgba(245,242,235,0.7)" : "#5C5753";
  const subtle = dark ? "rgba(245,242,235,0.55)" : "#8C8581";
  const cardBg = dark ? "rgba(255,255,255,0.05)" : "white";
  const cardBorder = dark ? "rgba(255,255,255,0.1)" : "rgba(45,38,34,0.1)";

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" style={{ color: fg }}>
      <div className="w-full max-w-md rounded-2xl p-8 shadow-sm fade-up text-center"
        style={{ background: cardBg, border: `1px solid ${cardBorder}` }}>
        <div className="w-14 h-14 rounded-full mx-auto flex items-center justify-center" style={{ background: brand.primary, color: "white" }}>
          <Mail className="w-6 h-6" />
        </div>
        <p className="overline mt-4" style={{ color: subtle }}>{brand.name} • Authorised partners only</p>
        <h1 className="font-heading font-bold text-2xl mt-2">Become a franchise partner</h1>
        <p className="mt-3 text-sm leading-relaxed" style={{ color: muted }}>
          {brand.name} supplies are available exclusively to our authorised franchise outlets.
          Franchise accounts are created by our team — public sign-ups are not enabled.
        </p>
        <p className="mt-5 text-sm" style={{ color: muted }}>
          To apply or onboard a new outlet, please email us at
        </p>
        <a href="mailto:admin@bigbillionfnb.com" data-testid="signup-mailto"
          className="font-mono font-bold text-lg mt-1 inline-block hover:underline" style={{ color: brand.primary }}>
          admin@bigbillionfnb.com
        </a>
        <div className="mt-8 flex flex-col gap-2">
          <Link to={`/b/${key}/login`}>
            <Button data-testid="goto-login-from-signup" className="w-full text-white" style={{ background: brand.primary }}>
              I already have credentials — sign in
            </Button>
          </Link>
          <Link to={`/b/${key}`} className="text-xs flex items-center justify-center gap-1 hover:underline mt-2" style={{ color: subtle }}>
            <ArrowLeft className="w-3 h-3" /> Back to {brand.name}
          </Link>
        </div>
      </div>
    </div>
  );
}
